'use client'
import * as React from 'react'

interface MenuState {
  allOpen: boolean
  setAllOpen: React.Dispatch<React.SetStateAction<boolean>>
  mobileOpen: boolean
  setMobileOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const MenuContext = React.createContext<MenuState>({
  allOpen: true,
  setAllOpen: () => void 0,
  mobileOpen: false,
  setMobileOpen: () => void 0,
})

export const useMenu = () => {
  const context = React.useContext(MenuContext)

  if (context === undefined) {
    throw new Error('useMenu must be used within a MenuProvider')
  }

  return context
}

export function MenuProvider({ children }: { children: React.ReactNode }) {
  const [allOpen, setAllOpen] = React.useState<boolean>(true)
  const [mobileOpen, setMobileOpen] = React.useState(false)

  return (
    <MenuContext.Provider
      value={{
        allOpen,
        setAllOpen,
        mobileOpen,
        setMobileOpen,
      }}
    >
      {children}
    </MenuContext.Provider>
  )
}
